// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"a80f74ec05a37b89","2013":"f702c3594d66d0b6","3807":"b8be12240b368061","6927":"072ef06e15d1ab7a","9099":"91af4a4e18c7cf94"}[chunkId] + ".js";
};